import { createSelector } from 'reselect';

import { AppState } from '../reducers/root.reducer';
import IInfo from '../types/common/IInfo';
import { useSelector } from 'react-redux';

const info = (state: AppState) => state.common.info;

const getInfo = info;

const getData = createSelector(getInfo, (info): IInfo => info.data);

const getCustomization = createSelector(getData, (data) => data?.customization);

const isLoading = createSelector(getInfo, (info): boolean => info.loading);

const getLocales = createSelector(
    getData,
    (info: IInfo): string[] => info.languages,
);

function useGetInfo() {
    return useSelector(getInfo);
}

const InfoSelectors = {
    getInfo,
    getData,
    isLoading,
    useGetInfo,
    getCustomization,
    getLocales,
};

export default InfoSelectors;
